export default () => ({
  tour: null,
});
